import { render, staticRenderFns } from "./supplierCreate.vue?vue&type=template&id=2e88433f&"
import script from "./supplierCreate.vue?vue&type=script&lang=js&"
export * from "./supplierCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports